import React, { useCallback, useEffect } from 'react';
import { Button, Flex, Text } from '@leverege/ui-elements';
import { useWizard } from '@leverege/ui-wizard';
import I18N from '@leverege/i18n';
import { GlobalState } from '@leverege/ui-redux';
import { Attributes } from '@leverege/ui-attributes';
import S from './Success.css';
const {
  t,
  tIcon
} = I18N.ns('pairing.imagine.UnpairingSuccess');
export default function UnpairingSuccess() {
  const {
    context,
    setHeader,
    setHeaderIcon,
    setNextText,
    setBackText,
    activeStep,
    wizardData
  } = useWizard();
  const {
    relationship,
    assetDelegate,
    tagDelegate,
    onClose
  } = context;
  const assetName = relationship.parentBlueprint.name;
  const tagName = relationship.blueprint.name;
  const asset = wizardData?.asset?.obj;
  const tag = wizardData?.tag?.obj;
  useEffect(() => {
    setHeader(t('header', {
      tagName,
      assetName
    }));
    setHeaderIcon(tIcon('headerIcon'));
    setNextText(t('unpairAnother'));
    setBackText(t('done'));
  }, []);
  const onClick = useCallback(({
    data,
    value
  }) => {
    if (data.type === 'asset') {
      GlobalState.dispatch(assetDelegate.goTo(data.id));
      onClose?.();
    } else {
      GlobalState.dispatch(tagDelegate.goTo(data.id));
      onClose?.();
    }
  }, []);
  const assetNameAttribute = Attributes.getAttribute('name', relationship.parentBlueprint.type);
  const tagNameAttribute = Attributes.getAttribute('name', relationship.blueprint.type);
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colL",
    align: "center"
  }, activeStep.image && /*#__PURE__*/React.createElement("img", {
    className: S.pairImage,
    src: activeStep.image.src,
    alt: activeStep.image.alt,
    height: activeStep.image.height || 136,
    width: activeStep.image.width || 136
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "formTitle"
  }, t('title', {
    assetName
  })), /*#__PURE__*/React.createElement("div", {
    className: S.buttonContainer
  }, asset && /*#__PURE__*/React.createElement(Button, {
    variant: "fakeList",
    eventData: {
      type: 'asset',
      id: asset.id
    },
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colS",
    align: "flex-start"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "caption"
  }, assetName), assetNameAttribute && /*#__PURE__*/React.createElement(Text, null, assetNameAttribute?.get(asset.data)))), tag && /*#__PURE__*/React.createElement(Button, {
    variant: "fakeList",
    eventData: {
      type: 'tag',
      id: tag.id
    },
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colS",
    align: "flex-start"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "caption"
  }, tagName), tagNameAttribute && /*#__PURE__*/React.createElement(Text, null, tagNameAttribute?.get(tag.data))))));
}
UnpairingSuccess.TYPE = 'imagine.pairing.UnpairingSuccess';